import { get } from './httpRequest';

const fetchPayoutApi = async ({ payoutId, reportDay }) => {
  const response = await get(`/payouts/${payoutId}/${reportDay}`);
  return response.data;
};

export default fetchPayoutApi;
